import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Checkbox,
  FormControlLabel,
  Badge,
} from "@mui/material";
import MyPlaylistForm from "./MyPlaylistForm";
import {
  setpreviewLogout,
  setpreviewPlaylistObject,
} from "../../redux/slices/Preview";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import StarIcon from "@mui/icons-material/Star";

const PlaylistSmallCardComponent = ({
  playlist,
  eventcustomisations,
  onSelectPlaylist,
}) => {
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const dispatch = useDispatch();

  const templates = useSelector((state) => state?.template?.template);
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay?.dataToDisplay
  );
  const currentLayoutResolution = useSelector(
    (state) => state?.resolution?.currentResolution
  );
  const [width, height] = currentLayoutResolution
    ? currentLayoutResolution?.split("x").map(Number)
    : [null, null];

  const [layoutOrientation, setLayoutOrientation] = useState(
    width && height ? (width > height ? "landscape" : "portrait") : null
  );

  const handleSelectPlaylist = (playlist) => {
    dispatch(setpreviewLogout());

    const meetingObject = JSON.parse(localStorage.getItem("meetingObject"));

    meetingObject.customProperties = {
      ...meetingObject.customProperties,
      isPlaylist: true,
      playlistId: playlist?.id,
      showTitle: true,
    };

    localStorage.setItem("meetingObject", JSON.stringify(meetingObject));
    const items = playlist.items;
    const currentCustomisationId = items[0]?.eventCustomisationId;
    const matchedCustomisation = eventcustomisations?.find(
      (customisation) => customisation.id === currentCustomisationId
    );
    const currentImageUrl = matchedCustomisation?.customisations?.[0]?.imageUrl;

    const updatedPlaylist = {
      ...playlist,
      firstImageUrl: currentImageUrl,
    };

    dispatch(setpreviewPlaylistObject(updatedPlaylist));
    setSelectedPlaylist(playlist);
  };

  useEffect(() => {
    const [width, height] = currentLayoutResolution
      ? currentLayoutResolution?.split("x").map(Number)
      : [null, null];
    const orientation = width > height ? "landscape" : "portrait";
    setLayoutOrientation(orientation);
  }, [currentLayoutResolution, selectedPlaylist]);

  const handleCheckboxChange = (playlistId) => {
    const newSelection = selectedPlaylist === playlistId ? null : playlistId;
    setSelectedPlaylist(newSelection);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        {playlist?.map((playlistEntry) => {
          const item = playlistEntry?.items?.[0];
          const matchedEntry = dataToDisplay.find(
            (entry) => entry.id === item?.content_ref
          );
          const playlistOrientation =
            matchedEntry?.customProperties?.metaData?.orientation;
          return (
            <Grid item xs={12} sm={6} key={playlistEntry.id}>
              <Box
                sx={{
                  border:
                    selectedPlaylist === playlistEntry.id
                      ? "3px solid #4caf50"
                      : "1px solid #f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "center",
                  borderRadius: "10px",
                  boxShadow: 2,
                  height: "100%",
                  position: "relative",
                  transition: "border 0.3s ease",
                  "&:hover .hover-content": {
                    opacity: 1,
                    visibility: "visible",
                  },
                }}
                onClick={() => handleSelectPlaylist(playlistEntry)}
              >
                {playlistOrientation === layoutOrientation && (
                  <Badge
                    badgeContent={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <StarIcon fontSize="small" />
                        RECOMMENDED
                      </span>
                    }
                    color="success"
                    sx={{
                      position: "absolute",
                      top: 20,
                      left: "70%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                    }}
                  />
                )}
                <CardContent
                  sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: 2,
                  }}
                >
                  <Box
                    className="hover-content"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      top: 2,
                      left: 1,
                      opacity: 0,
                      visibility: "hidden",
                      transition: "opacity 0.3s ease, visibility 0.3s ease",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPlaylist === playlistEntry.id}
                          onChange={() =>
                            handleCheckboxChange(playlistEntry.id)
                          }
                          color="success"
                        />
                      }
                    />
                  </Box>

                  <Box
                    key={matchedEntry?.id || playlistEntry.id}
                    sx={{ marginBottom: 1 }}
                  >
                    {matchedEntry?.customProperties?.html && (
                      <iframe
                        title="template-content"
                        srcDoc={matchedEntry.customProperties.html}
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "none",
                          borderRadius: "10px",
                          backgroundColor: "#f9f9f9",
                        }}
                      />
                    )}

                    {matchedEntry?.customisations?.[0]?.imageUrl &&
                      ([".mp4", ".avi", ".mov"].some((ext) =>
                        matchedEntry.customisations[0].imageUrl
                          .toLowerCase()
                          .endsWith(ext)
                      ) ? (
                        <CardMedia
                          component="video"
                          src={matchedEntry.customisations[0].imageUrl}
                          controls
                          sx={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      ) : (
                        <CardMedia
                          component="img"
                          image={
                            matchedEntry.customisations[0].imageUrl ||
                            "placeholder.jpg"
                          }
                          alt="Content Image"
                          sx={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      ))}

                    {matchedEntry?.imageUrl && (
                      <CardMedia
                        component="img"
                        image={matchedEntry?.imageUrl || "placeholder.jpg"}
                        alt="Content Image"
                        sx={{
                          width: "100%",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                    )}

                    <Typography
                      variant="subtitle1"
                      color="text.primary"
                      sx={{
                        fontSize: ".9rem",
                        fontWeight: 300,

                        textAlign: "center",
                      }}
                    >
                      {playlistEntry?.name || "Untitled"}
                    </Typography>
                  </Box>
                </CardContent>
              </Box>
            </Grid>
          );
        })}
      </Grid>
      <div style={{ marginTop: "1.5rem" }}>
        <MyPlaylistForm />
      </div>
    </Box>
  );
};

export default PlaylistSmallCardComponent;
